import { render, staticRenderFns } from "./AdviceModal.vue?vue&type=template&id=5d0f822f&scoped=true&"
import script from "./AdviceModal.vue?vue&type=script&lang=js&"
export * from "./AdviceModal.vue?vue&type=script&lang=js&"
import style0 from "./AdviceModal.vue?vue&type=style&index=0&id=5d0f822f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0f822f",
  null
  
)

export default component.exports